import { Button, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import IsLoggedIn from '../auth/IsLoggedIn';
import Logout from './Logout';
import ToggleDarkmode from './ToggleDarkmode';

function MarktTopNav() {
  const authState = useSelector((state) => state.auth);

  return (
    <Navbar bg='primary' variant='dark' expand='lg'>
      <div className='container'>
        <Navbar.Brand href='/markt'>Getränkemarkt - GK Office</Navbar.Brand>
        <IsLoggedIn>
          <Navbar.Toggle aria-controls='navbar' />
          <Navbar.Collapse id='navbar'>
            <Nav className='me-auto'>
              <NavDropdown title='Warenbestand' id='basic-nav-dropdown'>
                <NavDropdown.Item href='/markt/goods-receipt'>
                  Wareneingang buchen
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href='/markt/stock'>
                  Bestandsübersicht
                </NavDropdown.Item>
              </NavDropdown>
              {/*<Nav.Link href='/markt/sell'>Verkauf</Nav.Link>*/}
              <Nav.Link href='/markt/cash-register/overview'>Kassen</Nav.Link>
              <Nav.Link href='/markt/reservations'>Reservierungen</Nav.Link>
              <Button
                as={Nav.Link}
                href='/markt/sell'
                variant='secondary'
                className='bg-secondary text-white'
              >
                Verkauf&nbsp;
              </Button>
            </Nav>
            <Nav>
              <Navbar.Text>{authState?.username}</Navbar.Text>
              <Button className='ms-2' variant='light' href='/'>
                <i className='fas fa-up-right-from-square me-1' />
                GK Office
              </Button>
              <ToggleDarkmode />
              <Logout />
            </Nav>
          </Navbar.Collapse>
        </IsLoggedIn>
      </div>
    </Navbar>
  );
}

export default MarktTopNav;
